module.exports = __webpack_public_path__ + "img/xl_bk.789af6cf.jpg";